(function () {
    'use strict';

    angular
        .module('app')
        .directive('leaveFormWarning', leaveFormWarningDirective);

    leaveFormWarningDirective.$inject = ['$rootScope'];

    function leaveFormWarningDirective($rootScope) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.on('change', function () {
                    $rootScope.confirmLeaveForm = true;
                });

                element.on('submit', function () {
                    $rootScope.confirmLeaveForm = false;
                });
            }
        };
    }
})();